import { UpdateSummaryService } from '@/common/services/update-summary/update-summary.service';
import { UpdateSummaryRequest } from '@/core/domain/update-category/models/update-summary-request.model';
import { UpdateSummaryResponse } from '@/core/domain/update-category/models/update-summary-response.model';
import { UpdateSummaryRepository } from '@/core/domain/update-category/repositories/update-summary.repository';
import { selectReservation } from '@/core/reservation/store/reservation.selector';
import { environment } from '@/env/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import _ from 'lodash';
import { Observable, switchMap, first } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class UpdateSummaryImplRepository extends UpdateSummaryRepository {
    constructor(
        private readonly http: HttpClient,
        private readonly store: Store,
        private updateSummaryService: UpdateSummaryService,
    ) {
        super();
    }

    override getUpdateSummary(): Observable<UpdateSummaryResponse> {
        return this.store.select(selectReservation).pipe(
            first(),
            switchMap((reservation: unknown) => {
                const cartRequest: UpdateSummaryRequest = {
                    sessionId: _.get(reservation, 'uuid', ''),
                };
                return this.http.post<UpdateSummaryResponse>(
                    [
                        environment.alamoApi.BASE_HOST,
                        environment.alamoApi.ENDPOINTS.categoryUpdateSummary,
                    ].join('/'),
                    cartRequest,
                );
            }),
        );
    }
}
